import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import { CallState, LoadingState } from "@core/models";
import { PrintKiosk } from "@shared/models/print-kiosk.model";
import { sortByName } from "../sort-by-name";

export interface PrintKiosksState extends EntityState<PrintKiosk> {
  callState: CallState;
}

export const printKiosksAdapter: EntityAdapter<PrintKiosk> =
  createEntityAdapter<PrintKiosk>({
    selectId: (x) => x.deviceId,
    sortComparer: sortByName
  });

export const initialState: PrintKiosksState = printKiosksAdapter.getInitialState({
  callState: LoadingState.INIT,
});
